import { setStoreState } from '@vue-storefront/novulo-api';

export default async function storehandler(context) {
  setStoreState(context);
}
